module.exports = __webpack_public_path__ + "static/img/flow-img.216a2ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/flow-img.jpg
// module id = eENp
// module chunks = 2